/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE.
*/

import { CosmosEnumSectionSizes, EmbedSectionFragment } from "@cosmos/hygraph-schema";

import {
	BackgroundContainer,
	ResponsiveContainer,
	SectionContainer,
	CosmosEmbed,
	SectionHeading,
} from "@components/elements";
import { Box, VStack } from "@panda/jsx";
import { cx } from "@panda/css";
import { smStyles, mdStyles, lgStyles } from "@components/styles/size.style";

export const EmbedSection = ({ config, size, embed }: EmbedSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const validContent = Boolean(embed?.iframeSrc);
	if (!validHeading && !validContent) return null;
	const effectiveSize = size ?? CosmosEnumSectionSizes.Md;
	return (
		<BackgroundContainer
			bgAnimation={config?.backgroundAnimation}
			bgImageAsset={config?.backgroundImage}
			bgFullHeight={config?.backgroundFullHeight}
			edsBackgroundColor={config?.edsBackgroundColor}
		>
			<ResponsiveContainer>
				<SectionContainer disablePaddingBlockEnd={!!config?.disablePaddingBottom}>
					<VStack alignItems="stretch" gap="eds.dimension.56" className="embed-section">
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? (
							<Box w="full">
								<Box
									className={cx(
										effectiveSize === CosmosEnumSectionSizes.Sm ? smStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Md ? mdStyles : null,
										effectiveSize === CosmosEnumSectionSizes.Lg ? lgStyles : null,
									)}
									marginInline={config?.heading?.centeredVerticalStack ? "auto" : "unset"}
								>
									<CosmosEmbed {...embed} />
								</Box>
							</Box>
						) : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
